// Web: Next.js inlines NEXT_PUBLIC_* settings. Native builds use env.native.ts instead.
export const env = {
  API_URL: process.env.NEXT_PUBLIC_API_URL ?? '',
  APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION ?? '',
  APP_COMMIT: process.env.NEXT_PUBLIC_APP_COMMIT ?? '',
  APP_DEPLOYED_AT: process.env.NEXT_PUBLIC_APP_DEPLOYED_AT ?? '',
  GOOGLE_PLACES_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY ?? '',
  GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID ?? '',
  META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID ?? '',
  MAPBOX_API_KEY: process.env.NEXT_PUBLIC_MAPBOX_API_KEY ?? '',
  STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ?? '',
  E2E: process.env.NEXT_PUBLIC_E2E === 'true',
  IS_DEV: process.env.NODE_ENV === 'development',
} as const;

export type Env = typeof env;
